module.exports = __webpack_public_path__ + "img/tarj-cengeocol.93841631.png";